// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"fee91e08","503":"741f536c","710":"e635b056","911":"fc708c4f"}[chunkId] + ".chunk.js";
};